import React from "react"
import { Link } from "react-router-dom"

import { LinkButton } from "./styled"
import { CrossCompanyPhoneCheck } from "./auth/CrossCompanyPhoneCheck"
import { PROMO_LANDING_DESKTOP_IMAGE, PROMO_LANDING_MOBILE_IMAGE } from "../utils/promoLandingImages"
import { ROUTE_PATHS } from "../utils/routes"
import styles from "./GetStartedComponent.module.css"

export const GetStartedComponent = (props) => {
  const initialValues = {
    phoneNumber: ""
  }

  return (
    <section className={styles.promoLanding} aria-labelledby="promo-landing-heading">
      <div className={styles.card}>
        <div className={styles.media}>
          <picture>
            <source media="(min-width: 768px)" srcSet={PROMO_LANDING_DESKTOP_IMAGE} />
            <img
              src={PROMO_LANDING_MOBILE_IMAGE}
              alt=""
              className={styles.image}
              loading="eager"
              decoding="async"
            />
          </picture>
        </div>
        <div className={styles.content}>
          <h1 id="promo-landing-heading" className={styles.title}>
            Looking for rebates? You&apos;re in the right place.
          </h1>
          <p className={styles.subtitle}>
            Log in to see your order history and find available rebates.
          </p>
          {props.sprintRedirectActive ? (
            <div>
              <CrossCompanyPhoneCheck initialValues={initialValues} />
            </div>
          ) : (
            <LinkButton
              className={`btn ${styles.cta}`}
              id="btnSubmit"
              href={process.env.REACT_APP_TMO_ID_AUTH_URL}
              onClick={() => sessionStorage.setItem("isFromStandardPage", true)}
              primary
            >
              Get started
            </LinkButton>
          )}
          <div className={styles.links}>
            <p className={styles.statusBlock}>
              <span className={styles.statusLabel}>Already submitted a rebate?</span>{" "}
              <a className={styles.statusLink} href={process.env.REACT_APP_TMO_ID_AUTH_URL_STATUS} rel="noreferrer">
                Check rebate status
              </a>
            </p>
            <p>&nbsp;</p>
            <p className={styles.faqLine}>
              <span className={styles.faqPrompt}>Questions?</span>{" "}
              <Link className={styles.faqLink} to={ROUTE_PATHS.FAQ}>
                See rebate FAQ
              </Link>
            </p>
            <p className={styles.learnMoreLine}>
              Learn about{" "}
              <a href="https://www.t-mobile.com/support/new-to-tmobile/carrier-freedom" rel="noreferrer">
                Family Freedom
              </a>{" "}
              and{" "}
              <a href="https://www.t-mobile.com/support/new-to-tmobile/keep-and-switch" rel="noreferrer">
                Keep and Switch
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
